module.exports = __webpack_public_path__ + "7617d64c38a19b9b68a76370390196c5.svg";